import clsx from 'clsx'

import TableRowStateEmpty from 'app/KinerjaShared/components/StateEmpty'
import { TableRow, TableRowItem } from 'app/KinerjaShared/components/Table'
import StateError from 'app/KinerjaShared/components/StateError'

import type { FC, ReactNode } from 'react'

type TableRowStatesProps = {
  type: 'EMPTY' | 'ERROR'
  onClick?: () => void
  colSpan?: number
  children?: ReactNode
  className?: string
}

const TableRowStates: FC<TableRowStatesProps> = ({
  type,
  onClick,
  colSpan,
  children,
  className = '',
}) => {
  return (
    <TableRow className={clsx('border-none', className)}>
      <TableRowItem colSpan={colSpan || 7} className="p-9">
        {type === 'EMPTY' ? (
          <TableRowStateEmpty children={children} />
        ) : (
          <StateError onClick={onClick} />
        )}
      </TableRowItem>
    </TableRow>
  )
}
export default TableRowStates
